<!-- 交易详情 -->
<template>
  <div id="dealDeatails">
    <a-skeleton active :loading="loading" :title="false" :paragraph="{rows:10}">
      <div>
        <div class="header">
          <div class="project_stage">
            <pt-tag v-if="dealDO.dealOriginType == 1" :text="$t('deal.dealDetails.leaseProjectStageTypes.' + dealDO.projectStages)"></pt-tag>
            <pt-tag v-else :text="$t('deal.dealDetails.consultantProjectStageTypes.' + dealDO.projectStages)"></pt-tag>
          </div>
          <div class="show_history" v-if="false">
            <a-popover trigger="click" placement="bottomLeft" v-model="historyVisible" id="dealDetailsPopover">
              <div slot="content">
                <div style="min-width: 300px;">
                  <a-steps direction="vertical" progressDot :current="0">
                    <a-step v-for="(s,index) in stageHistory" :key="index">
                      <div slot="title">
                        <template v-if="dealDO.dealOriginType == 1">
                          <pt-tag size="small" v-if="index!=0" color="grey" :text="$t('deal.dealDetails.leaseProjectStageTypes.' + s.stage)" ></pt-tag>
                          <pt-tag size="small" v-if="index==0" :text="$t('deal.dealDetails.leaseProjectStageTypes.' + s.stage)" ></pt-tag>
                        </template>
                        <template v-else>
                          <pt-tag size="small" v-if="index!=0" color="grey" :text="$t('deal.dealDetails.consultantProjectStageTypes.' + s.stage)" ></pt-tag>
                          <pt-tag size="small" v-if="index==0" :text="$t('deal.dealDetails.consultantProjectStageTypes.' + s.stage)" ></pt-tag>
                        </template>
                      </div>
                      <div class="popover_content" slot="description">
                        <div>{{recordString(s)}}</div>
                      </div>
                    </a-step>
                  </a-steps>
                </div>
              </div>
              <a-button type="link" ghost style="padding:0;">
                <pt-icon type="icon-lishijiluomss" :styleObj="{fontSize:'20px'}"></pt-icon>
              </a-button>
            </a-popover>
          </div>
          <div class="function_buttons" v-if="showFunctionButton && !searchOverallFlag">

            <!-- 香港公司拥有 推荐盘源 -->
            <a-button v-if=" deptIdStr === '23' "  @click='openRecommend' v-show="dealEditAllow "><pt-icon type="icon-dianzan" class="btn-icon"></pt-icon>{{$t('deal.recommend.title')}}</a-button>

            <a-button @click="reactiveDeal" v-show="dealDO.projectStages == 13"><pt-icon type="icon-huifu"></pt-icon>{{$t('deal.dealDetails.dealDetail.reactive')}}</a-button>
            <a-button v-action:DEALCONTROLLER_REOPENDEAL @click="openDeal" :loading="openDealLoading" v-show="dealDO.projectStages == 12"><pt-icon type="icon-huifu"></pt-icon>{{$t('deal.dealDetails.dealDetail.openDeal')}}</a-button>
            <!-- 结佣 -->
            <a-button @click="showEditCommission" v-show="dealEditAllow"
            ><pt-icon type="icon-jieyong"></pt-icon>{{$t('deal.dealDetails.dealDetail.calCommission')}}</a-button>
            <!--关闭交易-->
            <a-button @click="showCloseDeal" v-show="dealEditAllow" ><pt-icon type="icon-zuofei"></pt-icon>{{$t('deal.dealDetails.dealDetail.closeDeal')}}</a-button>
            <!-- 跟进 -->
            <a-button @click="showCustomerRecord(null)" v-show="dealEditAllow"><pt-icon type="icon-genjin"></pt-icon>{{$t('deal.dealDetails.dealDetail.follow')}}</a-button>
            <!-- 提醒 -->
            <!--              <a-button @click="showTips" v-show="dealEditAllow"><pt-icon type="icon-tixing1"></pt-icon>{{$t('deal.dealDetails.dealDetail.remind')}}</a-button>-->
            <a-popover trigger="click" placement="bottomRight" v-model="showMoreButton">
              <div slot="content" style="display:flex;flex-direction: column;" class="more-btn">
                <template v-if="dealDO.dealOriginType != 2">
                  <!-- 原租约信息 -->
                  <div @click="openAddOldLease" v-show="dealEditAllow" class="btn" style="padding-top:4px;"><pt-icon type="icon-zengjia" class="btn-icon"></pt-icon>{{$t('deal.dealDetails.dealDetail.addOldLease')}}</div>
                  <!-- 新签租约 -->
                  <div @click="openAddNewLease" v-show="dealEditAllow && newLeaseDOS.length==0" class="btn"><pt-icon type="icon-zengjia" class="btn-icon"></pt-icon>{{$t('deal.dealDetails.dealDetail.addNewLease')}}</div>
                  <!--<div @click="showSwotAnalyze" v-show="dealEditAllow" class="btn"><pt-icon type="icon-fenxishi" class="btn-icon"></pt-icon>{{$t('deal.dealDetails.dealDetail.SWOTLabel')}}</div>-->
                </template>

                <template v-else>
                  <!-- 新增合同 -->
                  <div @click="openAddContract" v-show="dealEditAllow" v-if="contractVO == null" class="btn" style="padding-top:4px;"><pt-icon type="icon-zengjia" class="btn-icon"></pt-icon>{{$t('deal.dealDetails.dealDetail.addContract')}}</div>
                  <!-- 新增服务 -->
                  <div @click="openAddService" v-show="dealEditAllow" class="btn"><pt-icon type="icon-zengjia" class="btn-icon"></pt-icon>{{$t('deal.dealDetails.dealDetail.addService')}}</div>
                </template>
                <div  @click="showDealFileUpload" v-show="dealEditAllow"  class="btn"><pt-icon type="icon-shangchuanfujian"  class="btn-icon"></pt-icon>{{$t('deal.dealDetails.dealDetail.uploadFile')}}</div>



                <div @click="deleteDealConfirm" v-action:DEALCONTROLLER_DELETE class="btn" style="padding-bottom:4px;"><pt-icon type="icon-tubiao" class="btn-icon"></pt-icon>{{$t('deal.dealDetails.dealDetail.deleteDeal')}}</div>
              </div>
              <a-button v-show="dealEditAllow">
                {{$t('deal.dealDetails.dealDetail.more')}}
                <a-icon type="caret-right" :rotate="showMoreButton ? -90 : 90" style="font-size:10px;"/>
              </a-button>
            </a-popover>
          </div>
        </div>
        <div class="content">
          <div class="left" :style="leftStyle">
            <div class="deal_close" v-if="isDealClosed" :style="isDealFailed ? {background: '#FFF3F2'} : {background: '#F2FFF3'} ">
              <div class="deal_close_left">
                <pt-icon type="icon-wancheng" class="warning_icon" v-if="!isDealFailed"></pt-icon>
                <pt-icon type="icon-GroupCopy2" class="warning_icon" v-else></pt-icon>
              </div>
              <div class="deal_close_right" style="flex:auto">
                <div class="cancel_content">
                  <template  v-if="isDealFailed ">
                    <div v-if="dealDO.dealLoseCauseDO != '~'">
                      <div class="fail_reasons">
                        <div class="deal_close_label">
                          {{$t('deal.dealDetails.dealDetail.dealClose.failReasons')}}:
                        </div>
                      </div>
                      <div class="deal_close_content">
                        <a-row v-if="dealDO.dealLoseCauseDO.failReason.length > 0">
                          <a-col :span="8" v-for="(item,index) in dealDO.dealLoseCauseDO.failReasonValues" :key="`${item}-${index}`">{{item}}</a-col>
                        </a-row>
                        <a-row v-else-if="dealDO.dealLoseCauseDO.newFailReason">
                          <a-col :span="8">{{dealDO.dealLoseCauseDO.newFailReasonValues}}</a-col>
                        </a-row>
                        <div v-else>~</div>
                      </div>
                      <!--                        <div class="fail_reasons">-->
                      <!--                          <div class="deal_close_label">-->
                      <!--                            {{$t('deal.dealClose.other')}}:-->
                      <!--                          </div>-->
                      <!--                        </div>-->
                      <!--                        <div class="deal_close_content">-->
                      <!--                          <div>{{dealDO.dealLoseCauseDO.failRemarks}}</div>-->
                      <!--                        </div>-->
                      <div class="fail_reasons">
                        <div class="deal_close_label">
                          {{$t('deal.dealClose.summaryRisk')}}:
                        </div>
                      </div>
                      <div class="deal_close_content">
                        <div>{{dealDO.dealLoseCauseDO.summaryRisk}}</div>
                      </div>
                      <div class="fail_reasons">
                        <div class="deal_close_label">
                          {{$t('deal.dealClose.summaryReflect')}}:
                        </div>
                      </div>
                      <div class="deal_close_content">
                        <div>{{dealDO.dealLoseCauseDO.summaryReflect}}</div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="fail_reasons">
                        <div class="deal_close_label">
                          {{$t('deal.dealDetails.dealDetail.dealClose.failReasons')}}:
                        </div>
                      </div>
                      <div class="deal_close_content">
                        {{dealDO.closeRemarks}}
                      </div>
                    </div>

                  </template>

                  <template  v-else>
                    <div class="deal_close_label">
                      {{$t('deal.dealDetails.dealDetail.dealClose.closedRemarks')}}:
                    </div>
                    <div class="deal_close_content">
                      {{dealDO.closeRemarks}}
                    </div>
                  </template>

                </div>
                <div class="cancel_user deal_close_label">
                  <div style="margin-right: 40px;" class="deal_close_label">
                    {{$t('deal.dealDetails.dealDetail.dealClose.closeTime')}}:
                    {{dealDO.closeTime | dayjs}}
                  </div>
                  <div class="deal_close_label">
                    {{$t('deal.dealDetails.dealDetail.dealClose.closeUser')}}:
                    {{dealDO.closeUserName}}
                  </div>
                </div>
              </div>
            </div>
            <a-divider v-if="isDealClosed"></a-divider>
            <div v-show="isEdit">
              <div>
                <edit-deal ref="editDealRef"  :old-value="dealDO" @saveSuccess="updateDealDetailsSuccess" @validateFail="updateLoading = false" :dealOriginType="dealDO.dealOriginType" :dealAccountList="dealAccountList">
                  <div slot="header">
                    <a-button @click="isEdit = false" size="small" style="margin-right: 5px;">{{$t('baseVO.cacel')}}</a-button>
                    <a-button type="primary" :loading="updateLoading" size="small" @click="submitDealDetails">{{$t('baseVO.save')}}</a-button>
                  </div>
                </edit-deal>
              </div>
            </div>
            <customer-base @startEdit="isEdit = true"  :show-edit="showEditButton && dealDO.projectStages != 12 && dealDO.projectStages != 13" v-show="!isEdit" :customer-id="dealDO.customerId" >
              <div  class="tags" v-if="dealDO.pursuitsToDeal == 1">
                <div @click="toPursuitsDetail = true"  >
                  {{$t('deal.dealDetails.dealDetail.pursuitsToDeal')}}
                  <a-icon type="caret-right" style="color:#CACACA;"/>
                </div>
              </div>
            </customer-base>
            <!--交易详情Team  上面显示客户信息-->
            <div class="users"  v-show="!isEdit">
              <div class="titleRow">
                <div class="circleYellow"></div>
                <div class="titleText">Team</div>
                <div class="addHelperBtn" v-if="showFunctionButton" @click="addHelper" v-show="dealEditAllow">
                  <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                </div>
              </div>
              <div class="business_helper">
                <div v-for="a in dealAccountList" :key="a.employeeDO.id" class="user_info">
                  <a-avatar
                    slot="avatar"
                    icon="user"
                    shape="circle" :size="40"
                    :src="getHeadImg(a.employeeDO.headimg)"
                  />
                  <div>{{a.employeeDO.userName}}</div>
                </div>
              </div>
            </div>
            <!-- 折叠板 -->
            <a-collapse :bordered="false" v-model="activeKey" @change="collapseChanges">
              <template v-slot:expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? -90 : 90" />
              </template>
              <!-- 需求详情 -->
              <a-collapse-panel key="1" v-show="!isEdit" :style="panelStyle" :showArrow="false" disabled>
                <div slot="header" class="panel_header">
                  <div class="circle"></div>
                  <div class="panel_text" style="flex: 1;">{{$t('deal.addDeal.assessment')}}</div>
                  <div @click="dealDetailsEdit" v-if="false" style="margin-right: 20px;" v-show="dealDetailsEditVisible && dealEditAllow && showFunctionButton">
                    <pt-icon type="icon-bianji1" class="edit_icon"></pt-icon>
                  </div>
                  <a-row class="save_buttons" style="margin-right: 20px;" v-show="!dealDetailsEditVisible && dealEditAllow">
                    <a-button @click="cancelEditMode" size="small" style="margin-right: 5px;">{{$t('baseVO.cacel')}}</a-button>
                    <a-button type="primary" size="small" @click="submitDealDetails">{{$t('baseVO.save')}}</a-button>
                  </a-row>
                </div>
                <div style="margin-bottom: 30px">
                  <assessment-detail v-show="dealDetailsEditVisible" :detail="dealDO"></assessment-detail>

                  <!--                    <dealDetailsComponent :dealDetailsEditVisible="dealDetailsEditVisible" :hide-edit="true" ref="dealDetailsComponentRef" @cancelEditMode="dealDetailsEditVisible = true"-->
                  <!--                                          :defaultValue="dealDO" @updateDealDetailsSuccess="updateDealDetailsSuccess"></dealDetailsComponent>-->
                </div>
              </a-collapse-panel>
              <!-- 需求详情 -->
              <a-collapse-panel key="11"  v-show="!isEdit" :style="panelStyle" :showArrow="false" disabled>
                <div slot="header" class="panel_header">
                  <div class="circle"></div>
                  <div class="panel_text" style="flex: 1;">{{$t('deal.addDeal.baseInfo')}}</div>
                  <div @click="dealDetailsEdit"  v-if="false" style="margin-right: 20px;" v-show="dealDetailsEditVisible && dealEditAllow && showFunctionButton">
                    <pt-icon type="icon-bianji1" class="edit_icon"></pt-icon>
                  </div>
                  <a-row class="save_buttons" style="margin-right: 20px;" v-show="!dealDetailsEditVisible && dealEditAllow">
                    <a-button @click="cancelEditMode" size="small" style="margin-right: 5px;">{{$t('baseVO.cacel')}}</a-button>
                    <a-button type="primary" size="small" @click="submitDealDetails">{{$t('baseVO.save')}}</a-button>
                  </a-row>
                </div>
                <div style="margin-bottom: 30px">
                  <deal-base-detail :detail="dealDO" ></deal-base-detail>
                </div>
              </a-collapse-panel>
              <div>
                <linkman-table :linkman-list="linkManDOs" :base-info="dealDO" :mode-type="5" :show-edit-buttons="showFunctionButton"
                               @editLinkman="updateLinkman" @closeEdit="closeEdit" @deleteLinkman="deleteLinkman"></linkman-table>
              </div>


              <!-- 推荐盘源 -->
              <a-collapse-panel key="12"  :style="panelStyle" v-if=" deptIdStr === '23' "  >
                <div slot="header" class="panel_header_div">
                  <div  class="panel_header">
                    <div class="circle"></div><div class="panel_text">{{$t('deal.recommend.title')}}</div>
                  </div>
                  <div v-if="recommendList.length == 0">{{ $t('baseVO.empty') }}</div>
                </div>
                <div v-if="recommendList.length > 0" style="margin-bottom: 30px;">
                  <div style="background: #FCFCFC;margin:10px 0" v-for='(recommend,index) in recommendList' :key="recommend.id || index">
                    <div class='recommend'>
                      <div v-if='showRecommendEdit[index]' class='recommend_top'>
                        <div >
                          <a-checkbox  class='my_checkbox' v-model:checked="checked" >{{$t('deal.recommend.mainRecommend')}}</a-checkbox>
                        </div>
                        <div>
                          <span @click='saveRecommendEdit(index)'><pt-icon type="icon-queding" class="fileIcon"  ></pt-icon></span>
                          <span @click='closeRecommend(index)' style='margin-left: 5px'><pt-icon type="icon-a-xingzhuangcopy" class="fileIcon"  ></pt-icon></span>
                        </div>
                      </div>
                      <a-row  class='recommend_title' :gutter="15">
                        <a-col :span="1" class='main_icon'>
                          <pt-icon v-if='recommend.mainRecommend == 1' type="icon-zhutuijian" ></pt-icon>
                        </a-col>
                        <a-col  :span="5" >{{$t('deal.recommend.buildingName')}}</a-col>
                        <a-col  :span="4" >{{$t('deal.recommend.unitFloor')}}</a-col>
                        <a-col  :span="3" >{{$t('deal.recommend.newRent')}}</a-col>
                        <a-col  :span="3" >{{$t('deal.recommend.freeLeaseTerm')}}</a-col>
                        <a-col  :span="3" >{{$t('deal.recommend.leaseTerm')}}</a-col>
                        <a-col  :span="4" >{{$t('deal.recommend.startDate')}}</a-col>
                        <a-col  :span="1"  v-if='!showRecommendEdit[index] && showFunctionButton && !searchOverallFlag ' style='display: flex;justify-content: flex-end'>
                          <span @click='editRecommend(index)'><pt-icon type="icon-bianji2" class="fileIcon"  ></pt-icon></span>
                        </a-col>
                      </a-row>

                      <a-row  :gutter="15" class='recommend_value' v-show='!showRecommendEdit[index]'>
                        <a-col  :span="1"  class='main_icon'></a-col>
                        <a-col :span="5"  >
                          <a-tooltip :title="recommend.buildingName" placement="top">
                            <div style="overflow: hidden;white-space: nowrap;text-overflow:ellipsis;">
                              {{recommend.buildingName}}
                            </div>
                          </a-tooltip>
                        </a-col>
                        <a-col  :span="4"  >{{recommend.unitName}}/{{recommend.floorId}}F</a-col>
                        <a-col  :span="3" >${{recommend.newRent | NumberFormat }}</a-col>
                        <a-col :span="3"  >{{recommend.freeLeaseTerm }}{{budgetRentUnit}}</a-col>
                        <a-col :span="3" >{{recommend.leaseTerm }}{{budgetRentUnit}}</a-col>
                        <a-col :span="5" >{{recommend.startDate  }}</a-col>
                      </a-row>

                      <a-row  :gutter="15" v-show="showRecommendEdit[index]" class='recommend_value recommend_input'>
                        <a-col  :span="1" >
                          <div class='main_icon'>

                          </div>
                        </a-col>
                        <a-col  :span="5" >{{recommend.buildingName}}</a-col>
                        <a-col  :span="4" >{{recommend.unitName}}/{{recommend.floorId}}F</a-col>
                        <a-col  :span="3" >
                          <pt-input-number   :placeholder="$t('deal.recommend.enter')" :precision="2" style="width:100%;" v-model="recommendEditDO.newRent"  :min="0"></pt-input-number>
                        </a-col >
                        <a-col  :span="3" >
                          <a-input-number :formatter="value => `${value}${budgetRentUnit}`"  style="width:100%;"
                                          :parser="value => value.replace(budgetRentUnit, '')"  v-model="recommendEditDO.freeLeaseTerm"  :max='999' :min="0" :precision="1" ></a-input-number>
                        </a-col>
                        <a-col  :span="3" >
                          <a-input-number :formatter="value => `${value}${budgetRentUnit}`"  style="width:100%;"
                                          :parser="value => value.replace(budgetRentUnit, '')"  v-model="recommendEditDO.leaseTerm"    :max='999' :min="0"   :precision="1" :placeholder="$t('deal.recommend.enter')"></a-input-number>
                        </a-col>
                        <a-col  :span="5" >
                          <a-date-picker v-model='recommendEditDO.startDate' format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"  style="width:100%;"  ></a-date-picker>
                        </a-col>

                      </a-row>




                      <a-row class='recommend_value' style='margin-top: 10px'>
                        <div class='main_icon'></div>
                        <a-col :span="23"   v-if='!showRecommendEdit[index]' >{{recommend.remarks}}</a-col>
                        <a-col :span="23"   v-else>
                          <a-input :placeholder="$t('deal.recommend.remarks')" :maxLength="512" v-model="recommendEditDO.remarks" type="textarea"
                                   :autosize="{minRows:3,maxRows:3}"></a-input>
                        </a-col>
                      </a-row>
                    </div>


                  </div>
                </div>



              </a-collapse-panel>





              <!-- 原租约信息 -->
              <a-collapse-panel key="2"  :style="panelStyle"  >
                <div slot="header" class="panel_header_div">
                  <div  class="panel_header">
                    <div class="circle"></div><div class="panel_text">{{$t('deal.dealDetails.dealDetail.currLease')}}</div>
                  </div>
                  <div v-if="oldLeaseDOS.length == 0">{{ $t('baseVO.empty') }}</div>
                </div>
                <div v-if="oldLeaseDOS.length > 0" style="margin-bottom: 30px;">
                  <div style="background: #FCFCFC;margin:10px 0px">
                    <div>
                      <pt-tag style="cursor: pointer" v-for="(currentLeaseVO,index) in oldLeaseDOS" :key="index" @click.native="changeLeaseInfo(currentLeaseVO,index)" :color="currentLeaseKey == index ?'default':'grey'" :text="$t('deal.dealDetails.dealDetail.leaseTitle') + (index + 1)" type="triangle" size="small"></pt-tag>
                    </div>
                    <deal-current-lease :defaultValue="currentLeaseVO" :showEditButton="showEditButton" :key="currentLeaseKey" @refreshLease="selectOne(dealId)"></deal-current-lease>
                  </div>
                </div>
                <div v-else>
                  <pt-empty></pt-empty>
                </div>
              </a-collapse-panel>
              <!-- 合同 -->
              <!-- 新签租约 -->
              <a-collapse-panel key="5" :style="panelStyle" >
                <div slot="header" class="panel_header_div">
                  <div class="panel_header"><div class="circle"></div><div class="panel_text">{{$t('deal.dealDetails.dealDetail.newLease')}}</div></div>
                  <div v-if="newLeaseDOS.length == 0">{{ $t('baseVO.empty') }}</div>
                </div>


                <div v-if="newLeaseDOS.length > 0"  style="background: #FCFCFC;margin-bottom: 30px;">
                  <div style="margin-top: 10px;">
                    <div class="project_name">
                      <div style="flex: 1;">
                        <pt-tag color="grey"
                                :text="$t('deal.dealDetails.dealDetail.leaseTitle') + '1'" type="triangle" size="small"></pt-tag>
                      </div>
                      <!--                        <div @click="showLeaseDetails(newLeaseDOS[0].id)" style="margin-right: 18px;">-->
                      <!--                          <pt-icon type="icon-xiangqingcopy" class="viewIcon" :title="$t('lease.modal.viewCustomer')"></pt-icon>-->
                      <!--                        </div>-->
                    </div>
                  </div>
                  <dealCurrentLease :defaultValue="newLeaseDOS[0]" api="lease" @refreshLease="selectOne(dealId)"
                                    :showEditButton="showEditButton"></dealCurrentLease>
                </div>
                <div v-else>
                  <pt-empty></pt-empty>
                </div>
              </a-collapse-panel>
              <!-- 佣金记录 -->
              <a-collapse-panel key="6" :style="panelStyle" >
                <div slot="header" class="panel_header_div">
                  <div class="panel_header"><div class="circle"></div><div class="panel_text">{{$t('deal.dealDetails.dealDetail.commissionRecord')}}</div></div>
                  <div v-if="!showDealConfirm">{{ $t('baseVO.empty') }}</div>
                </div>


                <div style="margin-bottom: 30px;">
                  <div class="dealconfirm_block" v-if="showDealConfirm">
                    <div>
                      <pt-tag style="cursor: pointer" v-for="(d,index) in dealConfirmVOS" :key="index"
                              @click.native="changeDealConfirm(d,index)" :color="currentCommissionKey == index ?'default':'grey'"
                              :text="$t('deal.dealDetails.dealDetail.commissionRecord') + (index + 1)" type="triangle" size="small"></pt-tag>
                    </div>
                    <div v-if="!stopShowDetails && $route.path != '/manager/statistics/newMeeting'" style="display: flex;justify-content: flex-end;">
                      <div @click="showDealConfirmDetails(currentCommission.id)" style="margin-right: 15px;">
                        <pt-icon type="icon-xiangqingcopy" class="viewIcon" :title="$t('commission.commissionDetail.title')"></pt-icon>
                      </div>
                    </div>
                    <editDealConfirm :defaultValue="currentCommission" :showButtons="false" ref="dealConfirmRef"
                                     @refresh="initDealConfirmVO"></editDealConfirm>
                    <dealConfirmPartake :defaultValue="currentCommission" :showButtons="false" :show-other-files="true"
                                        ref="dealConfirmPartakeRef"></dealConfirmPartake>
                  </div>
                  <div v-else>
                    <pt-empty></pt-empty>
                  </div>
                </div>
              </a-collapse-panel>
              <!-- 服务记录 -->
              <a-collapse-panel key="9" :style="panelStyle" v-if="dealDO.dealOriginType == 2">
                <div slot="header" class="panel_header_div">
                  <div class="panel_header"><div class="circle"></div><div class="panel_text">{{$t('deal.service.details.serviceRecord')}}</div></div>
                  <div v-if="!serviceVO || serviceVO.length == 0">{{ $t('baseVO.empty') }}</div>
                </div>

                <div style="margin-bottom: 30px;" v-if="serviceVO && serviceVO.length > 0">
                  <div style="background: #FCFCFC;margin:10px 0px">
                    <div>
                      <pt-tag style="cursor: pointer" v-for="(serviceInfo,index) in serviceVO" :key="index" @click.native="changeServiceInfo(serviceInfo,index)"
                              :color="currentServiceKey == index ?'default':'grey'"
                              :text="$t('deal.service.details.serviceRecord') + (index + 1)" type="triangle" size="small"></pt-tag>
                    </div>
                    <serviceDetails @saveServiceSuccess="initServiceVO" :hasEditMode="dealEditAllow"
                                    :serviceVO="currentServiceVO"></serviceDetails>
                  </div>
                </div>
                <div v-else  style="background: #fafbfc;padding:10px 20px;margin-top: 5px;">
                  <pt-empty></pt-empty>
                </div>
              </a-collapse-panel>
              <!-- 附件 -->
              <a-collapse-panel key="7" :style="panelStyle" >
                <div slot="header" class="panel_header_div">
                  <div class="panel_header"><div class="circle"></div><div class="panel_text">{{$t('deal.dealDetails.dealDetail.attachment')}}</div></div>
                  <div v-if="dealFiles.length == 0">{{ $t('baseVO.empty') }}</div>
                </div>

                <div>
                  <div v-if="dealFiles.length > 0" style="padding: 0 16px 0 20px;">
                    <div v-for="(fileDO,index) in dealFiles" v-bind:key="fileDO.id">
                      <a-divider v-if="index != 0"/>
                      <div class="deal_files" :style="index == 0 ? {marginTop: '16px'} : {}">
                        <div style="margin-right: 10px;">
                          <pt-icon type="icon-fujian" :styleObj="{fontSize: '18px'}"></pt-icon>
                        </div>
                        <div style="flex: 1;font-size: 12px;color: #333333;display: flex; align-items: center;margin-right: 10px;">{{fileDO.fileName}}</div>
                        <div style="display: flex;align-items: center;">
                          <div @click="previewFile(fileDO)"  v-if="$util.matchPreviewType(fileDO.fileName)">
                            <pt-icon class="previewIcon" type="icon-yulancopy" :title="$t('baseVO.preview')"></pt-icon>
                          </div>
                          <div @click="downloadFile(fileDO)" style="margin-left: 20px">
                            <pt-icon class="downloadIcon" type="icon-xiazai" :title="$t('baseVO.download')"></pt-icon>
                          </div>
                          <div @click="deleteDealFile(fileDO)" v-if="dealEditAllow && showFunctionButton" style="margin-left: 20px">
                            <pt-icon type="icon-tubiao" :styleObj="{fontSize: '14px', cursor:'pointer'}" :title="$t('baseVO.delete')"></pt-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else style="background: #fafbfc;padding:10px 20px;margin-top: 5px;">
                    <pt-empty></pt-empty>
                  </div>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
          <div class="right">
            <div class="rightTitleRow">
              <!-- 跟进记录 -->
              <div :class="tabActiveKey == 1 ? 'activeTitle':'defaultTitle'"  @click="switchType(1)">
                <div class="titleFont">{{$t('deal.dealDetails.dealDetail.followRecord')}}</div>
                <div class="activeLine"></div>
              </div>
              <div :class="tabActiveKey == 2  ? 'activeTitle':'defaultTitle'"  @click="switchType(2)">
                <div class="titleFont">{{$t('deal.dealDetails.dealDetail.projectChange')}}</div>
                <div class="activeLine"></div>
              </div>
            </div>
            <div class="mainDiv">
              <div>
                <div v-if="tabActiveKey == 1" class="listDiv">
                  <customerRecordList :business-type='3' :datadict-childs='datadictChilds' :dealDO="dealDO" :customer-records="customerRecords" @showCustomerRecord="showCustomerRecord"
                                      :listPagination="listPagination" :showEditButtons="showFunctionButton" @refreshData='refreshData'
                  ></customerRecordList>
                </div>
                <div v-if="tabActiveKey == 2" class="listDiv">
                  <!--                    <reminderList :reminderQuery="{businessId:dealDO.id,remindType:'1'}" @editReminder="editReminder"-->
                  <!--                                  :showEditButtons="showFunctionButton"></reminderList>-->
                  <project-states-change :detail="dealDO" :project-states="stageHistory"></project-states-change>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-skeleton>
    <uploadFile :dealId="dealDO.id" :visible="dealFileUploadvisible" @onSuccess="onSuccess" @cancel="hideDealFileUpload"></uploadFile>
    <editDealSWOT :visible="swotVisible" :dealId="dealDO.id" @hide="hideSwot" @saveSuccess="swotSaveSuccess"></editDealSWOT>
    <customerRecord :customer-id='dealDO.customerId' :deal-origin-type="1" :loading="customerRecordLoading" :visible="customerRecordVisible" @hide="hideCustomerRecord" @saveSuccess="customerRecordSuccess" :dealId="dealDO.id"
                    :defaultValue="defaultCustomerRecord" ref="customerRecordRef"></customerRecord>
    <addTips :loading="tipLoading" :visible="tipsVisible" @saveSuccess="tipsSaveSuccess" @hide="hideTips" :dealId="dealId" ref="addTipsRef"></addTips>
    <pt-select-user :visible="selectUserVisible" @close="selectUserVisible = false" @ok="selectResultEvent"
                    v-model="dealAccountEmployees" ref="selectUserRef" :title="$t('deal.addDeal.dealDetails.addHelperIds')"></pt-select-user>
    <!-- 结佣 -->
    <pt-modal
      :title="$t('deal.dealDetails.dealDetail.calCommission')"
      :visible="editCommissionVisible"
      :width="800"
      :loading="commissionLoading"
      @cancel="hideCommission"
      @ok="saveDealConfirm"
    >
      <div slot="content">
        <newCommission :dealId="dealId" ref="newCommissionRef" @saveCommissionSuccess="saveCommissionSuccess" @saveCommissionFail="saveCommissionFail"
                       @cancelLoading="timeCancel"
                       :customerType="dealDO.customerType" :customerId="dealDO.customerId"
        ></newCommission>
      </div>
    </pt-modal>
    <!-- 新增租约 -->
    <pt-modal  :visible="addLeaseVisible" :loading="addLeaseLoading"
              @ok="submitEvent" @cancel="cancelEvent" :width="800"
    >
      <div slot="title">
        <div >
          <div v-if="newLease" class="secrecy_radio">
            <a-checkbox v-model:checked="secrecyTip">{{ $t('key14sheweibaomi') }}</a-checkbox>
            <a-tooltip placement="bottom" overlayClassName="add_new_lease_tips" overlayStyle="width:650px">
              <template #title>
                <div  style="width: 700px;">{{$t('deal.addDeal.secrecyTip')}}</div>
              </template>
              <pt-icon  type="icon-guize"/>
            </a-tooltip>
          </div>
          <span>{{$t(addLeaseTitle)}}</span>
        </div>
      </div>
      <div slot="content">
        <add-lease ref="addLeaseRef" :defaultCustomerId="dealDO.customerId"
                   :defaultAreaUnit="defaultAreaUnit" :defaultRentUnit="defaultRentUnit"></add-lease>
      </div>
    </pt-modal>
    <pt-modal :title="$t('deal.dealClose.title')" :visible="dealCloseVisible"
              :width="800" @cancel="hideCloseDeal" @ok="submitDealClose" :loading="dealCloseLoading"
    >
      <div slot="content">
        <dealClose :dealDO="dealDO" :is-commission="dealConfirmVOS.length > 0" ref="dealCloseRef" @refresh="closeAndRefresh" @validateFail="dealCloseLoading = false"></dealClose>
      </div>
    </pt-modal>
    <pt-modal :title="$t('deal.contract.addContract.title')" :visible="addContractVisible"
              :width="800" @cancel="hideAddContract" @ok="submitContract" :loading="addContractLoading"
    >
      <div slot="content">
        <addContract :dealId="dealId" ref="addContractRef" @saveContractSuccess="saveContractSuccess"
                     :dealCustomerType="dealDO.customerType" @validateFail="addContractLoading = false"
                     :customerId="dealDO.customerId"></addContract>
      </div>
    </pt-modal>
    <pt-modal :title="$t('deal.service.addService.title')" :visible="addServiceVisible" :loading="addServiceLoading"
              :width="800" @cancel="hideAddService" @ok="submitService"
    >
      <div slot="content">
        <addService :dealId="dealId" ref="addServiceRef" @saveServiceSuccess="saveServiceSuccess"
                    @validateFail="addServiceLoading = false"
        ></addService>
      </div>
    </pt-modal>
    <pt-modal :title="$t('lease.detail.title')" :visible="leaseDetailsVisible"
              :width="800" @cancel="hideLeaseDetails" @ok="hideLeaseDetails" :footer="true"
    >
      <div slot="content">
        <lease-detail :leaseId="leaseId" :showTopButton="false"></lease-detail>
      </div>
    </pt-modal>

    <!-- 推荐盘源 -->
    <pt-modal :title="$t('deal.recommend.title')" :visible="recommend.recommendVisible" :loading="recommend.recommendLoading"
              :width="800" @cancel="hideRecommend" @ok="submitRecommend"
    >
      <div slot="content">
        <add-recommend :dealId="dealId" ref='addRecommendRef' @saveRecommendSuccess="saveRecommendSuccess"
                       @validateFail="recommend.recommendLoading = false" ></add-recommend>
      </div>
    </pt-modal>


    <pt-drawer :title="$t('commission.commissionDetail.title')" :visible="dealConfirmDetailsVisible" :z-index="9999999"
               :width="800" @close="hideDealConfirmDetails" :footer="false"
    >
      <div slot="content">
        <commissionDetail :deal-confirm-id="dealConfirmId" :showFunctionButton="false" :show-deal-details="false"></commissionDetail>
      </div>
    </pt-drawer>
    <!--多次结佣提示-->
    <tip-modal
      :footer ="true"
      :visible="commissionTipModal.visible"
    >
      <div  slot="content" class="deleteOwnerMansionContent">
        <div class="divTip">
          <sapn> <pt-icon type="icon-GroupCopy2" class="tipIcon"></pt-icon></sapn>
          <span class="tipContent">{{$t('deal.commissionTipModal.tipStart')}}{{dealConfirmVOS.length}}{{$t('deal.commissionTipModal.tipEnd')}}</span>
        </div>
        <div class="divButton">
          <a-button  @click="closeCommissionTipModal" style="margin-right: 10px">{{$t('deal.commissionTipModal.button.cancel')}}</a-button>
          <a-button @click="openCommissionModal" key="submit" type="primary">{{$t('deal.commissionTipModal.button.submit')}}</a-button>
        </div>
      </div>
    </tip-modal>

    <pt-drawer :title="$t('track.trackDetail.detailTitle')" :visible="toPursuitsDetail" :width="1100" :show-footer="false" @close="toPursuitsDetail = false">
      <div slot="content">
        <track-detail :pursuitsId="dealDO.pursuitsId" :hideEdit="true" ></track-detail>
      </div>
    </pt-drawer>
  </div>
</template>

<script>
import newCommission from '../commission/module/newCommission'
import addLease from '@/views/database/lease/module/addLease'
import dealApi from '@/api/mine/deal'
import dealConfirmApi from '@/api/mine/dealConfirm'
import dealAccountApi from '@/api/mine/dealAccount'
import dealSourceApi from '@/api/mine/dealSource'
import dealStageHistoryApi from '@/api/mine/dealStageHistory'
import dealLinkmanApi from '@/api/mine/dealLinkman'
import dealSwotApi from '@/api/mine/dealSWOT'
import dealFilesApi from '@/api/mine/dealFiles'
import customerRecordsApi from '@/api/mine/customerRecords'
import dealDetailsComponent from './dealDetailsComponent'
import dealCurrentLease from './dealCurrentLease'
import editDealSWOT from './editDealSWOT'
import customerRecord from '../customer/editCustomerRecord'
import { getDatadictChildsByPath } from '@/api/sys/datadict'
import uploadFile from './uploadFile'
import editLinkman from './editLinkman'
import addTips from './addTips'
import selectUser from '@/components/form/selectUser'
import editDealConfirm from '@/views/mine/commission/module/editDealConfirm'
import dealConfirmPartake from '@/views/mine/commission/module/dealConfirmPartake'
import { getByCompanyIdAndType, unitTypeEnum } from '@/api/manager/unitUse'
import dealClose from './dealClose'
import addContract from './addContract'
import addService from './addService'
import contractDetails from './contractDetails'
import contractApi from '@/api/mine/contract'
import serviceApi from '@/api/mine/service'
import serviceDetails from './serviceDetails'
import leaseDetail from '../../database/lease/module/leaseDetail'
import reminderList from '../reminder/reminderList'
import customerRecordList from '../customer/customerRecordList'
import customerApi from '@/api/mine/customer'
import CustomerBase from '@/views/database/customer/module/customerBase'
import assessmentDetail from '@/views/mine/deal/assessmentDetail'
import dealBaseDetail from '@/views/mine/deal/dealBaseDetail'
import projectStatesChange from '@/views/mine/deal/projectStatesChange'
import EditDeal from '@/views/mine/deal/editDeal'
import trackDetail from '@/views/mine/pursuits/module/trackDetail'
import addRecommend from '@/views/mine/deal/recommend/addRecommend'
import dealRecommendBuildingApi from '@/api/mine/dealRecommendBuilding'
import dealRecommendBuilding from '@/api/mine/dealRecommendBuilding'
import moment from "moment";
export default {
  name: 'dealDetails',
  components:{
    EditDeal,trackDetail,dealRecommendBuilding,
    CustomerBase,assessmentDetail,dealBaseDetail,projectStatesChange,addRecommend,
    dealDetailsComponent,dealCurrentLease,editDealSWOT,customerRecord,uploadFile, editLinkman,addLease,
    addTips,selectUser,newCommission ,editDealConfirm, dealConfirmPartake,dealClose,addContract,addService,
    contractDetails, serviceDetails, leaseDetail, commissionDetail: () => import('../commission/module/commissionDetail'), reminderList, customerRecordList
  },
  props:{
    //打断佣金详情中显示的交易记录里面嵌套显示佣金信息
    stopShowDetails:{
      type: Boolean,
      default: false,
    },
    searchOverallFlag:{
      type: Boolean,
      default: false,
    },
    dealId: null,
    //显示操作按钮
    showFunctionButton:{
      type:Boolean,
      default:true
    },
    leftStyle:{

    },
    companyId:{
      type:String,
      default:undefined
    },
    showCustomerRecords:{
      type:Boolean,
      default:true
    },
    showEditButton: {
      type:Boolean,
      default:true
    },
  },
  data(){
    return {
      deptIdStr:'',
      secrecyTip:false,
      showRecommendEdit:[],
      budgetRentUnit:this.$t('deal.recommend.budgetRentUnit'),
      checked:false,
      mainRecommend:false,
      recommendEditDO:{
        newRent:undefined,
        freeLeaseTerm:undefined,
        leaseTerm:undefined,
        remarks:undefined,
        startDate:undefined
      },
      recommendLoading:false,

      commissionTipModal:{ //多次结佣弹窗提示
        title:"",
        visible:false,
        loading:false,
      },
      isEdit:false,
      updateLoading:false,
      commissionData:{},//结佣信息
      tipLoading:false,
      customerRecordLoading:false,
      customerRecordsTitle: null,
      addLeaseLoading: false,
      addContractLoading: false,
      addServiceLoading: false,
      dealCloseLoading: false,
      commissionLoading: false,
      openDealLoading: false,
      toPursuitsDetail: false,
      currentServiceVO:{},
      currentServiceKey:0,
      currentCommission:{},
      currentCommissionKey: 0,
      currentLeaseVO:{},

      recommendList:[],
      recommend:{
        recommendVisible:false,
        recommendLoading:false
      },



      currentLeaseKey:0,
      listPagination:{
        onChange: page => {
          this.listPagination.current = page
          this.selectCustomerRecords(this.dealId)
        },
        hideOnSinglePage:true,
        size:'small',
        defaultPageSize:5,
        pageSize:5,
        current: 1,
      },
      reminderDO:null,
      listType: 1,
      addLeaseTitle:'',
      dealDetailsEditVisible:true,
      linkmandEditVisible:true,
      contractVO:null,
      leaseId:null,
      dealConfirmId:null,
      serviceVO:null,
      defaultAreaUnit:null,
      defaultRentUnit:null,
      showMoreButton: false,
      leaseDetailsVisible: false,
      dealConfirmDetailsVisible: false,
      contractEditMode: false,
      addServiceVisible: false,
      addContractVisible: false,
      dealCloseVisible: false,
      loading:true,
      addLeaseVisible:false,
      newLease:null,
      dealConfirmEdit: false,
      defaultDealStage:null,
      stageHistory: [],
      defaultCustomerRecord: null,
      dealConfirmVOS: [],
      leaseInfoDO: null,
      selectUserVisible: false,
      tipsVisible: false,
      dealAccountList:[],
      dealAccountEmployees:[],
      customerRecordVisible:false,
      dealSwotDO:{},
      dealSourceDO:{},
      dealSourceTypes:[{}],
      swotVisible:false,
      dealFileUploadvisible: false,
      historyVisible: false,
      activeKey:['1','11'],
      lastActiveKey:['1','11'],
      tabActiveKey:1,
      dealDO: {},
      linkManDOs:[],
      dealLoseReason:{},
      panelStyle: 'background: #FFFFFF !important;border: 0;margin-bottom:10px;',
      dealFiles:[],
      brokerageRecords:[],
      customerRecords:[],
      datadictChilds:[],
      editCommissionVisible:false,
    }
  },
  mounted(){
    if(this.dealId != null){
      this.initDealLoseReason()
      this.init()
    }
  },
  computed:{
    dealEditAllow(){
      //通过交易阶段判断是否允许编辑
      if(this.dealDO.projectStages != 12 && this.dealDO.projectStages != 13 && this.showEditButton){
        return true
      }else{
        return false
      }
    },
    isDealClosed(){
      return this.dealDO.projectStages == 12 || this.dealDO.projectStages == 13
    },
    isDealFailed(){
      return this.dealDO.projectStages == 13
    },
    showDealConfirm(){
      if(this.dealConfirmVOS == null || this.dealConfirmVOS.length == 0){
        return false
      }else{
        return true
      }
    },
    dealSourceType(){
      if(this.dealSourceDO){
        return this.dealSourceTypes.find(d=>{ return d.wordKey == this.dealSourceDO.sourceType}) && this.dealSourceTypes.find(d=>{ return d.wordKey == this.dealSourceDO.sourceType}).wordValue
      }else{
        return null
      }
    },
    oldLeaseDOS(){
      if(this.dealDO.leaseLeaseInfoTypeVOS){
        let arr = this.dealDO.leaseLeaseInfoTypeVOS.filter(e=>{return e.newLease == false}).map(t=>{return t.leaseLeaseInfoVO});
        this.currentLeaseVO = arr[0]
        this.currentLeaseKey = 0;
        return arr;
      }else{
        return []
      }
    },
    newLeaseDOS(){
      if(this.dealDO.leaseLeaseInfoTypeVOS){
        return this.dealDO.leaseLeaseInfoTypeVOS.filter(e=>{return e.newLease == true}).map(t=>{return t.leaseLeaseInfoVO})
      }else{
        return []
      }
    },
  },
  methods:{

    editRecommend(index){
      this.showRecommendEdit.forEach((data,count)=>{
        this.$set(this.showRecommendEdit,count,false)
      })

      if(this.mainRecommend){
        this.checked = index == 0
      }

      let recommend = this.recommendList[index]
      this.recommendEditDO.newRent = recommend.newRent
      this.recommendEditDO.leaseTerm = recommend.leaseTerm
      this.recommendEditDO.freeLeaseTerm = recommend.freeLeaseTerm
      this.recommendEditDO.remarks = recommend.remarks == '~'?"":recommend.remarks
      this.recommendEditDO.startDate = recommend.startDate != '~'?recommend.startDate:undefined;

      this.$set(this.showRecommendEdit,index,true)
    },

    saveRecommendEdit(index){
      this.$loading.show();
      let recommendDO = this.recommendList[index]
      recommendDO.newRent = this.recommendEditDO.newRent
      recommendDO.leaseTerm = this.recommendEditDO.leaseTerm
      recommendDO.freeLeaseTerm = this.recommendEditDO.freeLeaseTerm
      recommendDO.remarks = this.recommendEditDO.remarks
      recommendDO.startDate = this.recommendEditDO.startDate;
      recommendDO.mainRecommend = this.checked ? 1 : 0


      if(recommendDO.freeLeaseTerm > recommendDO.leaseTerm ){
        this.$message.error(this.$t('deal.recommend.termTips'))
        this.$loading.hide();
        return
      }

      dealRecommendBuildingApi.update(recommendDO).then(res=>{
        this.$set(this.showRecommendEdit,index,false)
        if(res.code == 1){
          this.$message.success(res.message)
          this.init()
          this.$emit('refreshList');
          this.$loading.hide();
        }else{
          this.$message.error(res.message)
          this.$loading.hide();
        }
      })
    },

    closeRecommend(index){
      this.$set(this.showRecommendEdit,index,false)
    },



    saveRecommendSuccess(){
      this.hideRecommend()
      this.init()
      this.$emit('refreshList');
    },

    initRecommend(){
      let dealRecommendBuildingVO = {
        dealId:this.dealId
      }
      dealRecommendBuildingApi.selectAll(dealRecommendBuildingVO).then(res=>{
        if (res.code == 1){


          this.recommendList = res.data.records
          if(this.recommendList.length > 0 ){
            this.activeKey.push("12");
          }
          let total = res.data.total
          let showRecommendEdit = []
          if(total > 0 ){
            this.mainRecommend = res.data.records[0].mainRecommend == 1
            for(let i = 0 ; i < total ; i++ ){
              showRecommendEdit.push(false)
            }
          }
          this.showRecommendEdit = showRecommendEdit
          console.log('recommendList',res.data.records)
        }
      })
    },




    getRelationsSelects() {
      getDatadictChildsByPath('system.business_key.cms').then(res => {
        console.log('getRelationsSelects',res.data)
        this.datadictChilds = res.data

      })
    },
    closeCommissionTipModal(){
      this.commissionTipModal.visible = false;
      this.initDealConfirmVO();
    },
    openCommissionModal(){
      this.commissionTipModal.visible = false;
      this.editCommissionVisible = true
      this.$nextTick(()=>{
        this.$refs.newCommissionRef.selectDealConfirmVO(this.commissionData)
      })
    },
    reactiveDeal(){
      this.isEdit = false;
      this.customerRecordsTitle = 'deal.dealDetails.dealDetail.reactive'
      this.showCustomerRecord(null)
    },
    openDeal(){
      let _this = this
      this.$ptConfirm({
        title: this.$t('deal.dealDetails.dealDetail.openDealConfirm.title'),
        content: this.$t('deal.dealDetails.dealDetail.openDealConfirm.content'),
        okType: 'primary',
        onOk() {
          _this.openDealLoading = true
          return dealApi.reopenDeal(_this.dealId).then(res=>{
            if(res.code == 1){
              _this.$message.success(res.message)
              _this.$emit('refreshList', true)
              _this.init()
            }else{
              _this.$message.error(res.message)
            }
          }).finally(()=>{
            _this.openDealLoading = false
          })
        },
      })
    },
    changeServiceInfo(serviceInfo,index){
      this.currentServiceKey = index;
      this.currentServiceVO = serviceInfo;
    },
    changeDealConfirm(commissionInfo,index){
      this.currentCommissionKey = index;
      this.currentCommission = commissionInfo
    },
    changeLeaseInfo(leaseInfo,index){
      this.currentLeaseVO = leaseInfo
      this.currentLeaseKey = index
    },
    cancelEditMode(){
      this.$refs.dealDetailsComponentRef.cancelEditMode()
    },
    submitDealDetails(){
      this.updateLoading = true;
      this.$refs.editDealRef.submit()
    },
    editReminder(value){
      this.tipsVisible = true
      this.reminderDO = value
      this.$nextTick(()=>{
        this.$refs.addTipsRef.setDefaultValue(this.reminderDO)
      })
    },
    updateLinkman(){

    },
    closeEdit(){
      this.isEdit = false
    },
    deleteLinkman(){

    },
    dealDetailsEdit(){
      this.dealDetailsEditVisible = false
      this.$refs.dealDetailsComponentRef.toEditMode()
    },
    linkmanEditMode(){
      this.linkmandEditVisible = false
      this.$refs.editLinkmanRef.toEditMode()
    },
    recordString(obj){
      let str = '';
      if(this._i18n.locale != 'en-US'){
        str = obj.createrName + '在' + this.$moment(obj.createTime).format('YYYY-MM-DD') + this.$t('deal.dealRecord.updateText');
      }else if(this._i18n.locale == 'en-US'){
        str = this.$moment(obj.createTime).format('YYYY-MM-DD') + ' '+ obj.createrName + this.$t('deal.dealRecord.updateText');
      }
      return str;
    },
    closeAndRefresh(){
      this.hideCloseDeal()
      this.$emit('refreshList',true)
      this.init()
    },
    getHeadImg(headimg){
      return this.$util.getFileUrl(headimg)
    },
    addHelper(){
      this.dealAccountEmployees = this.dealAccountList.map(e=>{return e.employeeDO})
      this.selectUserVisible = true
    },
    customerRecordSuccess(){
      this.hideCustomerRecord()
      if(this.dealDO.projectStages == 13){
        this.$emit('refreshList',true)
        this.init()
      }else{
        this.selectOne(this.dealId)
        this.selectCustomerRecords(this.dealId)
        this.initDealStageHistory(this.dealId)
        this.$emit('refreshList',false)
        this.init()
      }
    },
    collapseChanges(allActiveKey){
      let this_ = this
      let key = allActiveKey.filter(x=>{
        return !this_.lastActiveKey.includes(x)
      })
      if(key.indexOf("4") >= 0){
        this.selectDealSwot()
      }
      if(key.indexOf("9") >= 0){
        this.initServiceVO()
      }
      this.lastActiveKey = allActiveKey
    },
    deleteDealConfirm(){
      let _this = this
      this.showMoreButton = false
      this.$ptConfirm({
        title: _this.$t('deal.dealDetails.dealDetail.deleteDealConfirm.title'),
        content: _this.$t('deal.dealDetails.dealDetail.deleteDealConfirm.content'),
        okType: 'primary',
        onOk() {
          _this.deleteDeal()
        },
        onCancel() {

        },
      });
    },
    deleteDeal(){
      dealApi.deleteDeal({id:this.dealId}).then(res=>{
        if(res.code == 1){
          this.$message.success(res.message)
          this.$emit('refreshList',true)
        }else{

        }
        this.showMoreButton = false
      })
    },
    deleteDealFile(file){
      let this_ = this
      this.$ptConfirm({
        title: this_.$t('confirmInfo.deleteFile.title'),
        content: this_.$t('confirmInfo.deleteFile.content'),
        onOk() {
          return new Promise((resolve, reject) => {
            dealFilesApi.deleteFile(file.dealFileDO).then(res=>{
              if(res.code == 1){
                this_.$message.success(res.message)
                this_.selectDealFiles(this_.dealId)
                resolve()
              }else{
                this_.$message.error(res.message)
                reject()
              }
            })
          }).catch(() => console.log('Oops errors!'));
        },
        onCancel() {},
      })
    },
    previewFile(file){
      this.$util.previewFile(file.id)
    },
    downloadFile(file){
      console.log(file)
      this.$util.dowLoadFile(file.id,file.fileName,this);
    },
    showEditCommission(){
      this.isEdit = false;
      let _this = this;
      dealConfirmApi.selectByDealId(this.dealId).then(res=>{
        if(res.code == 1){
          //判断该交易是不是第一次结佣
          this.commissionData = res.data;
          if(this.commissionData.active ){
            this.checkFirstCommission();
          }else{
            this.checkFirstCommissionNoLeaseInfo();
          }
        }
      })
    },
    checkFirstCommissionNoLeaseInfo(){
      let _this = this;
      dealConfirmApi.selectDealConfirmVOByDealId(this.dealId).then(res=>{
        if(res.code == 1){
          this.dealConfirmVOS = res.data;
          if(this.dealConfirmVOS.length > 0){
            this.currentCommission = res.data[0];
            this.currentCommissionKey = 0;
            this.commissionTipModal.visible = true;//打开多次结佣的提示窗
          }else{
            this.$ptConfirm({
              content:'该交易还未录入新签订的租约，请录入新签租约。',
              okText:'录入',
              icon:'test',
              onOk: () => {
                _this.openAddNewLease();
              },
              onCancel () {
                // _this.addNewCommissionInfo();
              }
            })

          }
        }
      })
    },
    addNewCommissionInfo(){
      this.editCommissionVisible = true
      this.$nextTick(()=>{
        this.$refs.newCommissionRef.selectDealConfirmVO(this.commissionData)
      })
    },
    checkFirstCommission(){
      dealConfirmApi.selectDealConfirmVOByDealId(this.dealId).then(res=>{
        if(res.code == 1){
          this.dealConfirmVOS = res.data;
          if(this.dealConfirmVOS.length > 0){
            this.currentCommission = res.data[0];
            this.currentCommissionKey = 0;
            this.commissionTipModal.visible = true;//打开多次结佣的提示窗
          }else{
            this.editCommissionVisible = true
            this.$nextTick(()=>{
              this.$refs.newCommissionRef.selectDealConfirmVO(this.commissionData)
            })
          }
        }
      })
    },
    showDealConfirmDetails(id){
      this.dealConfirmId = id
      this.dealConfirmDetailsVisible = true
    },
    showLeaseDetails(leaseId){
      this.leaseId = leaseId
      this.leaseDetailsVisible = true
    },
    hideCustomerRecord(){
      this.customerRecordVisible = false
      this.customerRecordLoading = false
      this.defaultCustomerRecord = null
      this.customerRecordsTitle = null
    },
    hideCommission(){
      this.editCommissionVisible = false
      this.commissionLoading = false
    },
    hideDealConfirmDetails(){
      this.dealConfirmDetailsVisible = false
    },
    hideSwot(){
      this.swotVisible = false
    },
    hideLeaseDetails(){
      this.leaseDetailsVisible = false
    },
    hideRecommend(){
      this.recommend.recommendVisible = false
      this.recommend.recommendLoading = false
    },
    hideCloseDeal(){
      this.dealCloseLoading = false
      this.dealCloseVisible = false
    },
    hideDealFileUpload(){
      this.dealFileUploadvisible = false
    },
    hideTips(){
      this.tipsVisible = false
      this.tipLoading = false
    },
    hideAddContract(){
      this.addContractVisible = false
      this.addContractLoading = false
    },
    hideAddService(){
      this.addServiceVisible = false
      this.addServiceLoading = false
    },

    hideAddLease(){
      this.cancelEvent();
      this.selectOne(this.dealId)
    },

    refreshData(){
      this.selectCustomerRecords(this.dealId)
      this.$emit('refreshList');
    },


    init(){

      this.dealDetailsEditVisible = true
      this.getRelationsSelects()

      this.selectOne(this.dealId)
      this.selectDealLinkman(this.dealId)
      this.selectCustomerRecords(this.dealId)
      this.selectDealAccount(this.dealId)
      this.selectDealSource(this.dealId)
      this.initDealStageHistory(this.dealId)
      this.initDealConfirmVO()
      this.initContract()
      this.initRecommend()
      this.selectDealFiles(this.dealId)

    },
    initDealLoseReason(){
      let this_ = this
      getDatadictChildsByPath('system.business_key.deallose').then(res=>{
        res.data.map(e=>{
          this_.dealLoseReason[e.wordKey] = e.wordValue
        })
      })
    },
    initContract(){
      let this_ = this
      contractApi.selectByDealId(this.dealId).then(res=>{
        if(res.code == 1){
          this_.contractVO = res.data
        }
      })
    },
    initDealConfirmVO(){
      dealConfirmApi.selectDealConfirmVOByDealId(this.dealId).then(res=>{
        if(res.code == 1){
          this.dealConfirmVOS = res.data;
          if(this.dealConfirmVOS.length > 0){
            this.currentCommission = res.data[0];
            this.currentCommissionKey = 0;
          }
        }
      })
    },
    initDealStageHistory(dealId){
      dealStageHistoryApi.selectByDealId(dealId).then(res=>{
        if(res.code == 1){
          this.stageHistory = res.data
        }else{

        }
      })
    },

    initDefaultAreaUnit(){
      let p = new Promise((resolve,reject)=>{
        getByCompanyIdAndType(unitTypeEnum.AREA).then(res=>{
          if(res.code == 1){
            this.defaultAreaUnit = res.data[0]
            resolve()
          }else{
            reject()
          }
        })
      })
      return p
    },
    initDefaultUnit(){
      Promise.all([this.initDefaultAreaUnit(),this.initDefaultRentUnit()]).then(()=>{
        this.addLeaseVisible = true
      })
    },
    initDefaultRentUnit(){
      let p = new Promise((resolve,reject)=>{
        getByCompanyIdAndType(unitTypeEnum.RENT).then(res=>{
          if(res.code == 1){
            this.defaultRentUnit = res.data[0]
            resolve()
          }else{
            reject()
          }
        })
      })
      return p
    },
    initServiceVO(){
      serviceApi.selectByDealId(this.dealId).then(res=>{
        if(res.code == 1){
          this.serviceVO = res.data;
          if(this.serviceVO.length > 0){
            this.currentServiceVO = this.serviceVO[0];
            this.currentServiceKey = 0;
          }
        }
      })
    },
    openAddOldLease(){
      this.initDefaultUnit()
      this.newLease = false
      this.showMoreButton = false
      this.addLeaseTitle = this.$t('baseVO.add') + this.$t('deal.dealDetails.dealDetail.addOldLease')
    },
    openAddNewLease(){
      this.initDefaultUnit()
      this.showMoreButton = false
      this.newLease = true
      this.addLeaseTitle = this.$t('baseVO.add') + this.$t('deal.dealDetails.dealDetail.addNewLease')
    },
    openAddContract(){
      this.showMoreButton = false
      this.addContractVisible = true
    },
    openAddService(){
      this.showMoreButton = false
      this.addServiceVisible = true
    },
    tipsSaveSuccess(){
      this.hideTips()
      this.init()
    },
    saveCommissionSuccess(){
      this.hideCommission()
      this.init()
    },
    saveCommissionFail(){
      this.commissionLoading = false
    },
    saveContractSuccess(){
      this.hideAddContract()
      this.init()
    },
    saveServiceSuccess(){
      this.hideAddService()
      this.initServiceVO()
    },
    selectDealSource(dealId){
      let this_ = this
      dealSourceApi.selectByDealId(dealId).then(res=>{
        if(res.code == 1) {
          this_.dealSourceDO = res.data
          this_.initDealSource()
        }else {

        }
      })
    },
    switchType(type){
      this.tabActiveKey = type;
    },
    selectResultEvent(value){
      if(!this.dealAccountEmployees || this.dealAccountEmployees.length == 0){
        this.$message.error(this.$t('deal.addDeal.dealDetails.errorInfo.zeroHelperIds'))
        return
      }
      let dealAccountVO = this.dealAccountEmployees.map(e=>{
        return {dealId:this.dealId,employeeDO:e}
      })
      dealAccountApi.updateByDealId(dealAccountVO).then(res=>{
        if(res.code == 1){
          this.$message.success(res.message)
          this.selectDealAccount(this.dealId)
        }else{
          this.$message.error(res.message)
        }
      })
    },
    showCloseDeal(){
      this.isEdit = false;
      this.dealCloseVisible = true
    },
    showTips(){
      this.reminderDO = null
      this.tipsVisible = true
    },
    submitContract(){
      this.addContractLoading = true
      this.$refs.addContractRef.saveContract()
    },

    submitRecommend(){
      this.recommend.recommendLoading = true
      this.$refs.addRecommendRef.submit()
    },


    submitDealClose(){
      this.dealCloseLoading = true
      this.$refs.dealCloseRef.submit()
    },
    submitEvent(){
      let leaseLeaseInfoVO = this.$refs.addLeaseRef.extractLeaseInfoVO()
      if(!leaseLeaseInfoVO){
        return
      }
      leaseLeaseInfoVO.secrecyTip = this.secrecyTip
      let LeaseLeaseinfoTypeVO = {businessId: this.dealId, newLease: this.newLease, leaseLeaseInfoVO: leaseLeaseInfoVO }
      this.addLeaseLoading = true
      dealApi.saveNewLease(LeaseLeaseinfoTypeVO).then(res=>{
        if(res.code == 1){
          this.init()
          this.hideAddLease()
          this.$message.success(res.message)
        }else{
          this.$message.error(res.message)
        }
        this.addLeaseLoading = false
      })
    },
    submitService(){
      this.addServiceLoading = true
      this.$refs.addServiceRef.submit()
    },
    cancelEvent(){
      this.addLeaseVisible = false
    },
    initDealSource(){
      let this_ = this
      getDatadictChildsByPath('system.business_key.deal_source_set').then(res=>{
        this_.dealSourceTypes = res.data
      })
    },
    onSuccess(){
      this.selectDealFiles(this.dealId)
      this.dealFileUploadvisible = false
    },
    showCustomerRecord(value){
      this.isEdit = false;
      this.customerRecordVisible = true
      if(value){
        this.defaultCustomerRecord = value
        this.$nextTick(()=>{
          this.$refs.customerRecordRef.initDefaultValue()
        })
      }else{
        this.$nextTick(()=> {
          this.$refs.customerRecordRef.setDefaultValue(this.dealDO)
        })
      }
    },
    selectDealAccount(dealId){
      let this_ = this
      dealAccountApi.listAllByDealId(dealId).then(res=>{
        if(res.code == 1){
          this_.dealAccountList = res.data
        }else{

        }
      })
    },
    selectDealSwot(){
      let this_ = this
      dealSwotApi.selectByDealId(this.dealId).then(res=>{
        if(res.code == 1){
          this_.dealSwotDO = res.data != null ? res.data : {}
        }
      })
    },
    selectCustomerRecords(dealId){
      let this_ = this
      customerRecordsApi.selectByBusinessId(dealId,'deal',2,{
        size:this.listPagination.pageSize,
        current:this.listPagination.current,
      }).then(res=>{
        this_.customerRecords = res.data.records
        this_.listPagination.total = res.data.total
      })
    },
    swotSaveSuccess(){
      this.hideSwot()
      this.selectDealSwot()
    },
    saveDealConfirm(){
      this.commissionLoading = true
      this.$refs.newCommissionRef.validate()
    },

    timeCancel(){
      setTimeout(() => {
        this.commissionLoading = false
      },1000)
    },


    saveSuccess(){
      this.selectOne(this.dealId)
    },
    selectOne(id){
      let this_ = this
      this.loading = true
      dealApi.selectOne(id).then(res=>{
        this_.dealDO = res.data
        this_.deptIdStr = this_.dealDO.deptIdStr
        this_.dealDO.startTime = this_.$moment(this_.dealDO.startTime)
        this_.dealDO.endTime = this_.$moment(this_.dealDO.endTime)
        // if(this_.dealDO.customerType == 1){
        //   this_.getColumnACustomerFollower(this_.dealDO.customerId)
        // }
      }).finally(()=>{
        this.loading = false
      })
    },
    selectDealLinkman(dealId){
      let this_ = this
      dealLinkmanApi.selectByDealId(dealId).then(res=>{
        this_.linkManDOs = res.data.records
      })
    },
    selectDealFiles(dealId){
      let this_ = this
      dealFilesApi.selectByDealId(dealId).then(res=>{
        this_.dealFiles = res.data.records
      })
    },
    showDealFileUpload(){
      this.showMoreButton = false
      this.dealFileUploadvisible = true
    },

    openRecommend(){
      this.showMoreButton = false
      this.recommend.recommendVisible = true
    },


    async showFile(id){
      return "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
    },
    showSwotAnalyze(){
      this.swotVisible = true
      this.showMoreButton = false
    },
    toEditMode(){
      this.dealConfirmEdit = true
      this.$refs.dealConfirmRef.toEditMode()
      this.$refs.dealConfirmPartakeRef.toEditMode()
    },
    updateContract(){
      this.$refs.contractDetailsRef.saveContract()
    },
    updateDealDetailsSuccess(){
      this.updateLoading = false;
      this.saveSuccess()
      this.init();
      this.dealDetailsEditVisible = true
      this.$emit('refreshList')
      this.isEdit = false;
    },
    updateContractSuccess(){
      this.contractEditMode = false
      this.initContract()
    }
  },
  watch:{
    dealId(){
      this.init()
    },
    showMoreButton(){
      this.isEdit = false;
    }
  }
}
</script>

<style scoped lang="less">
.deleteOwnerMansionContent{
  display: flex;
  flex-direction: column;
  height: 70px;
  .divTip{
    display: flex;
    flex-direction: row;
    align-items: center;
    .tipIcon{
      cursor: pointer;font-size: 30px
    }
    .tipContent{
      margin-left: 5px;
    }
  }
  .divButton{
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}


#dealDeatails{
  .mainDiv{
    margin-top: 20px;
    border-top:1px solid #F0F0F0;
  }
  .rightTitleRow{
    display: flex;
    flex-direction: row;
    .activeTitle{
      padding-top: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 30px;
      cursor:pointer;
      align-self: flex-end;
      .titleFont{
        font-size: 14px;
        color: #000000;
      }
      .activeLine{
        margin-top: 12px;
        background: #FABE00;
        width: 50px;
        height:4px;
      }
    }
    .defaultTitle{
      padding-top: 10px;
      margin-right: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor:pointer;
      align-self: flex-end;

      .titleFont{
        font-size: 14px;
        color: #999999;
      }
      .activeLine{
        margin-top: 12px;
        background: transparent;
        width: 50px;
        height:4px;
      }
    }
  }
  .listDiv{
    padding: 10px 20px;
    width: 400px;

  }
  background: #FCFDFD;
  .project_name{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .dealconfirm_block{
    margin: 10px 0;
    background: #FCFCFC;
  }
  .header{
    background: #FFF;
    display: flex;
    padding: 8px 0;
    background: #FAFBFC;
    width: 100%;
    left: 0;
    top: 0;
    .project_stage{
      display: flex;
    }
    .show_history{
      flex: 1;
      display: flex;
      align-items: center;

    }
    .function_buttons{
      flex: 2;
      display: flex;
      justify-content: flex-end;
      padding-right: 20px;
      .ant-btn{
        margin-left: 10px;
      }
    }
  }
  .content{
    .deal_close{
      .warning_icon{
        font-size: 30px;
      }
      min-height: 130px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: row;
      padding: 20px;
      border-radius: 0 0 4px 4px;
      .deal_close_label{
        font-size: 12px;
        color: #999999;
      }
      .deal_close_content{
        word-break: break-all;
        font-size: 12px;
        color: #333333;
        margin-bottom: 25px;
      }
      .deal_close_content:last-child{
        margin-bottom: 10px;
      }
      .deal_close_left{
        margin-right: 20px;
      }
      .deal_close_right{
        display: flex;
        flex-direction: column;
        justify-content: center;
        .cancel_content{
          flex: 1;
          font-size: 12px;
          color: #333333;
        }
        .cancel_user{
          display:flex;
          flex-direction: row;
          font-size: 12px;
          color: #333333;
        }
      }
    }
    .plus_icon{
      width: 16px;
      height: 16px;
      border: 1px solid #8E8E8E;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .title{
      font-size: 12px;
      color: #999999;
    }
    .content_text{
      font-size: 12px;
      color: #333333;
    }
    background-color:#ffffff;
    padding:0;
    display: flex;
    .left{
      padding: 20px;
      background: #FFF;
      flex: 1 0 650px;
      min-width: 650px;
      .users{
        .titleRow{
          background: #FAFBFC;
          height: 40px;
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-bottom: 5px;
          .circleYellow{
            width: 12px;
            height: 12px;
            background: #FABE00;
            border-radius: 50%;
            margin: 0 10px;
          }
          .titleText{
            font-size: 14px;
            color: #333333;
            font-weight: bold;
          }
          .addHelperBtn{
            width: 16px;
            height: 16px;
            margin-left: auto;
            margin-right: 20px;
            border: 1px solid #8E8E8E;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .addIcon{
              font-size: 12px;
              color: #8E8E8E;
            }
          }
          .addHelperBtn:hover{
            border: 1px solid #FABE00;
            .addIcon{
              color: #FABE00;
            }
          }
        }
        .business_helper{
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          background: #FAFBFC;
          margin-bottom: 30px;
          padding: 22px 15px;
          .user_info{
            margin-right: 20px;
            text-align: center;
            margin-bottom: 10px;
            min-width:70px;
          }
        }
      }
      .customer_name{
        font-size: 17px;
        color: #333333;
        margin-bottom: 10px;
        font-weight: bold;
      }
      .panel_header_div{
        display:flex;justify-content: space-between;flex:auto;align-items: center;padding-right: 40px;
        >div:last-child{

        }

      }
      .panel_header{
        display: flex;
        align-items: center;
        .circle{
          margin-left: 12px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #FABE00;
        }
        .panel_text{
          padding: 0 10px;
          color: #333333;
          font-size: 14px;
          font-weight: bold;
        }
      }
      .ant-col-8, .ant-col-24{
        display: flex;
      }
      .ant-divider-horizontal{
        margin: 10px 0;
      }
      .swot_back_cycle{
        width: 70px;
        height: 70px;
        background: #F4F5F8;
        border-radius: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .left_swot{
        padding-right: 10px;
        display:flex;
        justify-content: flex-end;
      }
      .right_swot{
        padding-left: 10px;
        display:flex;
        justify-content: flex-start;
      }
      .swot{
        width: 100%;
        background: #FAFBFC;
        .content{
          background: #FAFBFC;
          font-size: 12px;
          color: #333333;
          letter-spacing: 0;
          padding: 0 25px 25px 25px;
        }
        .tag_left{
          padding: 3px 5px;
          float: left;
          background: #FFF3DF;
          border: 1px solid #FFD694;
          border-radius: 3px;
          font-size: 12px;
          color: #FA9B00;
          letter-spacing: 0;
          text-align: center;
        }
        .tag_right{
          padding: 3px 5px;
          float: right;
          background: #FFF3DF;
          border: 1px solid #FFD694;
          border-radius: 3px;
          font-size: 12px;
          color: #FA9B00;
          letter-spacing: 0;
          text-align: center;
        }
      }
      .info_lines{
        margin-bottom: 15px;
      }
    }
    .right{
      background-color: #FAFBFC;
      flex: 1 0 350px;
      max-width: 500px;
      margin-top: 20px;
      padding:0px 20px;
    }
  }
}

.recommend{
  padding: 10px 15px 10px 10px;
  .recommend_top{
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .main_icon{
    width: 30px;
    font-size: 12px;
    font-weight: 400;
  }
  .recommend_title{
    display: flex;
    align-content: center;
    font-size: 12px;
    color: #999999;
    font-weight: 600;
  }
  .recommend_value{
    display: flex;
    align-content: center;
    font-size: 12px;
    color: #333333;
    font-weight: 600;
  }

  .recommend_input .ant-input{
    color: #333333 !important;
    font-weight: 600 !important;
  }

  .recommend_input /deep/ input{
    color: #333333 !important;
    font-weight: 600 !important;
    font-size: 12px;
  }




  .my_checkbox {
    zoom: 88%;
    color: #979797;
    font-weight: 600;
  }
}

</style>
<style lang="less">

.add_new_lease_tips{
  .ant-tooltip-content{
    width: 650px;
  }
}

.secrecy_radio{
  position: absolute;
  left: 50px;
}

#dealDeatails{
  .collapse_buttons{
    margin-right: 20px;
    flex:1;
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
  .editBtn{
    text-align: right;
    .editIcon{
      font-size: 18px;
      cursor:pointer;
    }
  }
  .ant-collapse-borderless{
    background-color: #ffffff !important;
  }
  .ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box{
    padding: 0;
  }
  .ant-collapse .ant-collapse-item .ant-collapse-header .anticon {
    left: initial;
    right: 16px;
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header{
    padding: 9px 0px 9px 0px;
    background: #FAFBFC;
    margin-left: 0 !important;
  }

  .edit_icon{
    font-size: 18px;
    float:right;
    cursor:pointer;
  }

  .deal_files{
    display: flex;
  }
}
.ant-steps-dot .ant-steps-item-content{
  width: initial !important;
}
.popover_content{
  padding-top:8px;
  font-size: 12px;
  color: #999999;
}
.more-btn{
  .btn{
    cursor:pointer;
    padding: 8px 0;
    .btn-icon{
      margin-right: 10px;
    }
  }
}
.myTabs > .ant-tabs-bar{
  border-bottom:10px solid #F4F5F8;
  text-align: center;
  margin: 0 !important;
}
.tags{
  >div{
    background: #EDEDED;
    border-radius: 2px;
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 600;
    margin-right: 15px;
    padding: 2px 5px;
    min-width: 45px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
